import type { Dispatch } from "redux";
import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export function loadCustomer() {
	return (dispatch) => {
		dispatch(actions.customerRequest());
		return server.getCustomer().then((customer) => dispatch(actions.customerResponse(customer)));
	};
}

export function updatePhoneNumber(phoneCountryCode: string, phoneNumber: string) {
	return (dispatch) => {
		dispatch(actions.phoneNumberUpdateRequest({ phoneCountryCode, phoneNumber }));
		return server.updatePhoneNumber(phoneCountryCode, phoneNumber).then(() => dispatch(actions.phoneNumberUpdateResponse({ phoneCountryCode, phoneNumber })));
	};
}

export function updateEmail(email: string) {
	return (dispatch) => {
		dispatch(actions.emailUpdateRequest(email));
		return server
			.updateEmail(email)
			.then(() => dispatch(actions.emailUpdateResponse(email)))
			.catch((e) => {
				if (e.type === server.SERVER_VALIDATION_ERROR) {
					dispatch(
						actions.serverValidationError({
							message: e.message,
							cause: actions.EMAIL_UPDATE_REQUEST,
						}),
					);
					return false;
				}
				throw e;
			});
	};
}

export function bekreftKontaktInfo({ email, phoneCountryCode, phoneNumber }) {
	return (dispatch) => {
		dispatch(actions.bekreftKontaktInfoRequest({ email, phoneCountryCode, phoneNumber }));
		return server.bekreftKontaktInfo(email, phoneCountryCode, phoneNumber).then(() => dispatch(actions.bekreftKontaktInfoResponse({ email, phoneCountryCode, phoneNumber })));
	};
}

export function updateMarkedsforingSamtykke(samtykke: boolean, ignoreError?: boolean) {
	return (dispatch) => {
		dispatch(actions.updateMarkedsforingSamtykkeRequest(samtykke));
		return server
			.updateMarkedsforingSamtykke(samtykke)
			.then(() => dispatch(actions.updateMarkedsforingSamtykkeResponse(samtykke)))
			.catch((e) => {
				if (!ignoreError) {
					throw e;
				}
			});
	};
}

export function updateDybdeSamtykke(samtykke: boolean, ignoreError?: boolean) {
	return (dispatch) => {
		dispatch(actions.updateDybdeSamtykkeRequest(samtykke));
		return server
			.updateDybdeSamtykke(samtykke)
			.then(() => dispatch(actions.updateDybdeSamtykkeResponse(samtykke)))
			.catch((e) => {
				if (!ignoreError) {
					throw e;
				}
			});
	};
}

export function updateNorskPensjonSamtykke(samtykke: boolean, ignoreError?: boolean) {
	return (dispatch) => {
		dispatch(actions.updateNorskPensjonSamtykkeRequest(samtykke));
		return server
			.updateNorskPensjonSamtykke(samtykke)
			.then(() => dispatch(actions.updateNorskPensjonSamtykkeResponse(samtykke)))
			.catch((e) => {
				if (!ignoreError) {
					throw e;
				}
			});
	};
}

export function updateDigitaltForstevalgSamtykke(samtykke) {
	return (dispatch) => {
		dispatch(actions.updateDigitaltForstevalgSamtykkeRequest(samtykke));
		return server.updateDigitaltForstevalgSamtykke(samtykke).then(() => dispatch(actions.updateDigitaltForstevalgSamtykkeResponse(samtykke)));
	};
}

export function requestFatcaData() {
	return (dispatch) => {
		dispatch(actions.fatcaDataRequest());
		return server.getFatcaData().then((data) => dispatch(actions.fatcaDataResponse(data)));
	};
}

export function updateFatcaData(data) {
	return (dispatch) => {
		dispatch(actions.fatcaDataUpdateRequest(data));
		return server.setFatcaData(data).then(() => dispatch(actions.fatcaDataUpdateResponse(data)));
	};
}

export function customerTimeout() {
	return (dispatch) => dispatch(actions.customerTimeout());
}

export function loadCustomerF2100AccountNumber() {
	return (dispatch) => {
		dispatch(actions.customerF2100AccountNumberRequest());
		return server.getCustomerF2100AccountNumber().then((account) => dispatch(actions.customerF2100AccountNumberResponse(account || null)));
	};
}

export function setCustomerF2100AccountNumber(accountNumber: string) {
	return (dispatch: Dispatch) => {
		dispatch(actions.setCustomerF2100AccountNumberRequest(accountNumber));
		return server.setCustomerF2100AccountNumber(accountNumber).then((response) =>
			dispatch(
				actions.setCustomerF2100AccountNumberResponse({
					accountNumber,
					success: response === true,
				}),
			),
		);
	};
}

export function fetchLoForvaltningsform() {
	return (dispatch) => {
		dispatch(actions.fetchLoForvaltningsformRequest());
		return server.isLoMemberWithIndeksForvaltning().then((data) => dispatch(actions.fetchLoForvaltningsformResponse(data)));
	};
}

export function updateRiskAssessmentReminder(value) {
	return (dispatch) => {
		dispatch(actions.updateRiskAssessmentReminderRequest(value));
		return server.updateRiskAssessmentReminder(value === "AUTHORIZED").then(() => dispatch(actions.updateRiskAssessmentReminderResponse(value)));
	};
}

export function isLoMember() {
	return (dispatch) => {
		dispatch(actions.isLoMemberRequest());
		return server.isLoMember().then((response) => dispatch(actions.isLoMemberResponse(response)));
	};
}

export function getDistributor(bankNr?) {
	return (dispatch) => {
		dispatch(actions.getDistributorRequest(bankNr));
		return server.getDistributor(bankNr).then((response) => dispatch(actions.getDistributorResponse(response)));
	};
}
